define('loginVueApp/routes',[
  'vue!loginVueApp/pages/LoginPage',
  'vue!loginVueApp/pages/CreateUserPage',
  'vue!loginVueApp/pages/SplashPage',
], function (LoginPage, CreateUserPage, SplashPage) {
  return function () {
    return {
      profile: LoginPage,
      login: LoginPage,
      create: CreateUserPage,
      guest: CreateUserPage,
      splash: SplashPage,
    };
  };
});

